import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "loading-circle-animation" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "profile-main-loader" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "loader" }, [
    /*#__PURE__*/_createElementVNode("svg", {
      class: "circular-loader",
      viewBox: "25 25 50 50"
    }, [
      /*#__PURE__*/_createElementVNode("circle", {
        class: "loader-path",
        cx: "50",
        cy: "50",
        r: "20",
        fill: "none",
        stroke: "#70c542",
        "stroke-width": "2"
      })
    ])
  ])
], -1)
const _hoisted_3 = [
  _hoisted_2
]

import {onMounted, ref, watch} from 'vue';

	
export default /*#__PURE__*/_defineComponent({
  __name: 'LoadingCircleAnimation',
  props: {
    width: {}
  },
  setup(__props: any) {

_useCssVars(_ctx => ({
  "1de0912a": (width.value)
}))

	const width = ref("200px");

	const props = __props;

	onMounted(() => {
		setWidth();
	});

	watch(() => props.width, () => {
		setWidth();
	});

	function setWidth() {
		if(props.width == undefined)
			width.value = "200px";
		else
			width.value = props.width + "px";
	}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}
}

})